async function customCheckout() {
  document.querySelector('.cart-btn').innerHTML = 'Processing...';
  
  const response = await fetch('/cart.js');
  const cart = await response.json();
  
  const cartToken = cart.token;

  window.location.href = `http://sunnypajamas.com/checkout/${cartToken}`;
}
// ---------------------------------------------------------------------------
// 👉 MONEY FORMATTER
// ---------------------------------------------------------------------------

var Shopify = Shopify || {};

var currentCurrency = document.getElementById('current-symbol').innerHTML;
var currentCurrencyIso = '';

// do a fetch request to get the currency
// fetch('/cart.js')
// .then(response => response.json())
// .then(data => {
//   currentCurrency = data.currency;
//   Shopify.money_format = currentCurrency + " {{amount}}";
//   console.log(data)
// })

Shopify.money_format = currentCurrency + " {{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};





// ---------------------------------------------------------------------------
// 👉 ADD TO CART
// ---------------------------------------------------------------------------


function addToCart(){
  let formData = new FormData(document.querySelector('.tommyboi'));
  document.querySelector('.add-to-cart-btn').innerHTML = 'Adding...';
  
  console.log("FUCK U")
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => {
    return response.json();
  })
  .then(response => {
        showCart();
        // Send data
        // sendCartDataToFBWebhook(response.final_price)
      })
      .catch((error) => {
        console.error('Error:', error);
      })
      .finally(() => {

        document.querySelector('.add-to-cart-btn').innerHTML = 'Done!';
        setTimeout(() => {
          document.querySelector('.add-to-cart-btn').innerHTML = 'Add To Cart';
        }, 1000)
      }) 
}


function loadTrackerScript(callbackFunct) {
  const script = document.createElement('script');
  script.src = "https://www.sunnysleepwear.com/tracker.js";
  script.async = true;

  // Call the callback
  script.onload = function() { callbackFunct() };

  // Error handling
  script.onerror = function() { console.error("Failed to load the tracker script.") };

  document.head.appendChild(script);
}
const sendCartDataToFBWebhook = async (price) => {

  console.log('sending data to fb...')


  loadTrackerScript(() => {
      trackAddToCart(price);
  });


}

// Add event listener to add to cart button
// if (document.querySelector('.add-to-cart-btn')){
//   document.querySelector('.add-to-cart-btn').addEventListener('click', addToCart);
// }

function updateCart(){
  //send fetch request
  fetch('/?view=cart')
  .then(response => response.text())
  .then (cartData => {
    console.log('done', cartData)
    // find element in cart data
    let cartDataElm = document.createElement('div');
    cartDataElm.innerHTML = cartData;
    let stage = cartDataElm.querySelector('#cart-content').innerHTML;
    let currentNumber = cartDataElm.querySelector('#cart-number-inner').innerHTML;
    document.querySelector('#cart-content').innerHTML = stage;  
    // if there is no opacity-1 class on .cart-bottom area, add
    if (!document.querySelector('.cart-bottom-area').classList.contains('opacity-1')){
      setTimeout(() => {
      document.querySelector('.cart-bottom-area').classList.add('opacity-1')
      }, 0)
    }
    // if there is no opacity-1 class on .Free-Gift-Wrapper, add
    if (!document.querySelector('.Free-Gift-Wrapper').classList.contains('opacity-1')){
      setTimeout(() => {
        document.querySelector('.Free-Gift-Wrapper').classList.add('opacity-1')
        }, 0)
    }  
})    
.finally(() => {
  freeGift()
})   
};

// Update Cart Qty
function updateCartQuantity(line, qty){
  

      fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ quantity: qty, line: line})
      })
      .then(response => {
          return response.json();
      })
      .then(data => {
          updateCart();
  
      })
      .catch((error) => {
          console.error('Error:', error);
      })
       .finally(() => {  

       })
    }

// Show Cart Slider 
function showCart() {
  document.querySelector('.slider-cart-container').style.display = 'block';
  updateCart();

  setTimeout(() => {
      document.querySelector('.slider-cart-bg').classList.add('opacity-1')
      document.querySelector('.slider-cart-stage').classList.add('slide-in-cart-pop')

      lazyload()
  },0)
};
document.querySelector('.nav-cart-icon').addEventListener('click', showCart);

// Hide Cart Slider
function hideCart() {
  document.querySelector('.slider-cart-bg').classList.remove('opacity-1')
  if (document.querySelector('.cart-bottom-area')) {
    document.querySelector('.cart-bottom-area').classList.remove('opacity-1')
  }


  if (document.querySelector('.Free-Gift-Wrapper')) {

    document.querySelector('.Free-Gift-Wrapper').classList.remove('opacity-1')
  }
  setTimeout(() => {
  document.querySelector('.slider-cart-stage').classList.remove('slide-in-cart-pop')
  },100)
  setTimeout(() => {
    document.querySelector('.slider-cart-container').style.display = 'none';
  },500)
};
document.querySelector('.slider-cart-bg, .slider-cart-close-icon').addEventListener('click', hideCart);


// ---------------------------------------------------------------------------
// 👉 CURRENCY
// ---------------------------------------------------------------------------

// Show Currency Slider 
// $('.currency-container, .mm-bottom-region-container').click(showCurrency );

// function showCurrency() {
//   $('.currency-slider-container').show();
//   setTimeout(() => {
//       document.querySelector('.currency-slider-bg').classList.add('opacity-1')
//       document.querySelector('.currency-slider-stage').classList.add('slide-in-currency-pop')
//   },0)
// }

// Hide Currency Slider
$('.currency-slider-bg, .currency-close-img').click(function() {
  document.querySelector('.currency-slider-bg').classList.remove('opacity-1')
  document.querySelector('.currency-slider-stage').classList.remove('slide-in-currency-pop')
  setTimeout(() => {
    $('.currency-slider-container').hide();
  },500)
});


  // Currency Update - Can Change To Ajax Later
  document.querySelectorAll(".currency-selection-container").forEach(item => {
    item.addEventListener("click", event => {
      document.getElementById("countryCode").value =item.getAttribute("iso-code");
      document.getElementById("localization_form_tag").submit();
    });
  });



// ---------------------------------------------------------------------------
// 👉 INSTANT SEARCH
// ---------------------------------------------------------------------------

// Show Instant Search
$('.nav-instant-search').click(function() {
  $('.search-pop-container').show();
  setTimeout(() => {
      document.querySelector('.search-pop-bg').classList.add('opacity-1')
      document.querySelector('.search-pop-stage').classList.add('slide-in-search-pop')
      document.querySelector('.search-pop-bar-text').focus()
  },0)
});

// Hide Instant Search
$('.search-pop-bg, .search-pop-close').click(function() {
  document.querySelector('.search-pop-bg').classList.remove('opacity-1')
  document.querySelector('.search-pop-stage').classList.remove('slide-in-search-pop')
  setTimeout(() => {
      $('.search-pop-container').hide();
  },500)
});

// Main Search Function
function predictiveSearch() {
  console.log('HI')
  let searchValue = document.querySelector('.search-pop-bar-text').value;
  fetch('/search/?type=product&q=' + searchValue)
    .then(response => {
        return response.text();
    })
    .then (searchData => {
      console.log(searchData, 'searchData')
        document.querySelector('.search-pop-main-area-2').innerHTML = searchData;
      })
    .finally(() => { changePriceToFlex(); lazyload() });
}

// Add event listener to search bar
document.querySelector('.search-pop-bar-text').addEventListener('keyup', predictiveSearch);

// Clear search
function clearSearch() {
  document.querySelector(".search-pop-bar-inner").reset();
  predictiveSearch();
}

// Event listener for clear search
document.querySelector('.search-pop-clear').addEventListener('click', clearSearch);

// Shortcuts for top searched
function changeSearchValue(i){
  document.querySelector('#search-input').value = i.innerHTML;
  predictiveSearch();

}


// ---------------------------------------------------------------------------
// 👉 QUICK VIEW
// ---------------------------------------------------------------------------


// Show Quick View
function showQv(){
    $('.quick-view-container').show();
    setTimeout(() => {
        document.querySelector('.quick-view-bg').classList.add('opacity-1')
        document.querySelector('.quick-view-stage').classList.add('slide-in-right')
    },0)
};

// Hide Quick View
function hideQv() {
    document.querySelector('.quick-view-bg').classList.remove('opacity-1')
    document.querySelector('.quick-view-stage').classList.remove('slide-in-right')
    setTimeout(() => {
        $('.quick-view-container').hide();
    },500)
}

// Get The ID (Product Handle) On Quick View Button Click
function getQVID(id) {
  var productHandle = id;
  quickViewBuild(productHandle);
  showQv()
}

// Main Quick View Function
function quickViewBuild(productHandle) {

  // Clear images
  var imgContainer = document.getElementById("imageid");
  imgContainer.innerHTML = `<div class="qv-image skeleton"></div>
  <div class="qv-image skeleton"></div>
  <div class="qv-image skeleton"></div>
  <div class="qv-image skeleton"></div>
  <div class="qv-image skeleton"></div>
  <div class="qv-image skeleton"></div>`

  // Clear title
  var titleContainer = document.getElementById("titleid");
  titleContainer.innerHTML = ""

  // Clear the price
  var priceContainer = document.getElementById("priceid");
  priceContainer.innerHTML = ""

  // Clear the compare price
  var comparePriceContainer = document.getElementById("compareatpriceid");
  comparePriceContainer.innerHTML = "";

  if (comparePriceContainer.style.display = "none") {
    comparePriceContainer.style.display = "block";
  }

  // Clear the product form
  var productForm = document.querySelector('.qv-product-form')
  productForm.innerHTML = ""

  fetch('https://sunnyofficial.co/products/' + productHandle + '.json')
    .then(response => {
      return response.json(); 
    })
    .then (data => {

      // Create The Images
      imgContainer.innerHTML = ""
      for (var i = 0; i < data.product.images.length; i++) {
        var image = document.createElement("img");
        image.className = "qv-image skeleton";
        // load image width and height 500x500
        image.id = "quick-view-image";
        image.src=data.product.images[i].src+"?width=500&height=500";
        imgContainer.appendChild(image);
      }

      // Creating the Title
      var title = document.createElement("h2");
      title.id = "qv-product-title"
      title.innerHTML = data.product.title;
      titleContainer.appendChild(title);

      // Creating the Price
      var price = document.createElement("h2");
      price.id = "qv-product-price"
      price.innerHTML = Shopify.formatMoney(data.product.variants[0].price);
      priceContainer.appendChild(price);

      // Creating the compare at price
      if (data.product.variants[0].compare_at_price.length > 0) {
          var compareatprice = document.createElement("h2");
          compareatprice.id = "qv-product-compare-at-price"
          compareatprice.innerHTML = Shopify.formatMoney(data.product.variants[0].compare_at_price);
          comparePriceContainer.appendChild(compareatprice);
      } else {
        console.log('not')
          comparePriceContainer.style.display = "none";
      }

      // Creating see more link
      document.getElementById("seemoreid").href="/products/" + productHandle;

      // Get the product form
      fetch('/products/' + productHandle)
      .then(response => {
        return response.text();
      })
      .then (productData => {
        const newDocument = new DOMParser().parseFromString(productData, 'text/html')
        
        var hello = newDocument.querySelector('.ppage-selector-area')
        var productForm = document.querySelector('.qv-product-form')
        // for every var-select in the productForm
        var varSelects = hello.querySelectorAll('.var-slct')
        for (var i = 0; i < varSelects.length; i++) {
          varSelects[i].removeAttribute('onclick')
          varSelects[i].setAttribute('onclick', 'changeFunction(this)')
        }

        productForm.appendChild(hello)   
      })
      .finally (() => {

      })
    })
}

function changeFunction(e) {
  var productHandle = e.dataset.handle
  quickViewBuild(productHandle)
  
}



// Function To Update Product Tile
function updateProductTile(e) {

  var productPageUrl = "https://sunnyofficial.co" + e.dataset.link

  // run fetch request
  fetch(productPageUrl)
    .then(response => {
        return response.text();
    })
    .then (productData => {
   
        // Create div
        var div = document.createElement("div");
        div.innerHTML = productData;

        // Get new tile
        var tile = div.querySelector('.hidden-product-tile').innerHTML

        // Get current tile
        var tile2 = e.dataset.name
        console.log(tile2)

        // Update the tile
        var one = e.parentElement
        var two = one.parentElement
        var three = two.parentElement
        var four = three.parentElement
        
        four.innerHTML = tile
        lazyload()
        changePriceToFlex()

     
        
    })
  


}



// ---------------------------------------------------------------------------
// 👉 PRODUCT PAGE
// ---------------------------------------------------------------------------




// Variant Selector Update HTML
function varSelector(e) {

  // if product url contains product
  if (window.location.href.includes("product")) {

    console.log(e.dataset.link)

    var productPageUrl = "https://sunnyofficial.co" + e.dataset.link

    // run fetch request
    fetch(productPageUrl)
      .then(response => {
          return response.text();
      })
      .then (productData => {

          // Create div
          var div = document.createElement("div");
          div.innerHTML = productData;

          // Get product page wrapper
          var productWrapper = div.querySelector('.ppage-wrapper')
          var productPage = document.querySelector('.ppage-wrapper')
          productPage.innerHTML = productWrapper.innerHTML


          // Update the url
          history.replaceState(null, null, "https://sunnyofficial.co" + e.dataset.link);
          lazyload()

          
      })
  }




}



// Product Form
function productFormTest(e) {
  var name = e.dataset.name
  var id = e.id
  var qty = e.dataset.value
  const select = document.querySelector('#master-product-select');
  select.value = e.id

  if (window.location.href.includes(name)) {
    history.replaceState(null, null, '/products/' + e.dataset.name + '?variant=' + e.id );
  }
  // Remove 'active' class from all variant selectors
  document.querySelectorAll('.variant-selector').forEach(function(e) {
      e.classList.remove('active-b')
  })
  // Add 'active' class to current variant selector
  document.getElementById(id).className = 'variant-selector active-b'
  checkQty()


  var price = e.dataset.price
  var comparePrice = e.dataset.comparePrice

  console.log(price, comparePrice)

  // Update price
  if (document.querySelector('.product-price')){
    document.querySelector('.product-price').innerHTML = Shopify.formatMoney(price)
  }
  if (document.querySelector('.product-compare-price')){
    document.querySelector('.product-compare-price').innerHTML = Shopify.formatMoney(comparePrice)
  }

  if (document.querySelector('#qv-product-price')){
    document.querySelector('#qv-product-price').innerHTML = Shopify.formatMoney(price)
  }
  if (document.querySelector('#qv-product-compare-price')){
    document.querySelector('#qv-product-compare-price').innerHTML = Shopify.formatMoney(comparePrice)
  }

  // If stock if not available
  var stock = e.dataset.stock
  if (stock == 'false') {
    document.querySelector('.add-to-cart-btn').innerHTML = 'Sold Out'
  }
  else {
    document.querySelector('.add-to-cart-btn').innerHTML = 'Add To Cart'
  }
  

}










// Check URL For Active Variant And Add Correct Class
function checkUrl() {
  const queryString = window.location.search
  // if queryString includes filter.v.availability=1
  if (queryString.includes('?variant')) {
      const select = document.querySelector('#master-product-select');
      var id = select.value
      document.getElementById(id).className = 'variant-selector active-b'
  }
}

// Check Qty Function
function checkQty() {
  // if url param includes variant
  const queryString = window.location.search
  if (queryString.includes('?variant')) {
   
    var iIcon = document.querySelector('.i-icon')
  
    const select = document.querySelector('.active-b');
    var qty = select.dataset.value
      // If qty is less than 5 but greater than 0
      if (qty > 0 && qty < 10) {
        document.querySelector('.variant-inventory').innerHTML = '🔥 Only ' + qty + ' left in stock!'
      } else {
        document.querySelector('.variant-inventory').innerHTML = ''
      }
    if (qty <= 0) {
      var preOrder = document.createElement("div");
      preOrder.className = "pre-order-container"
      preOrder.innerHTML = `This item is avalible & ready for order with the Perfect Fit Guarantee.`
      document.querySelector('.pre-order-info').classList.remove('hidden')
      document.querySelector('.pre-order-info').classList.add('green-bg')
      document.querySelector('.pre-order-info').innerHTML = ""
      document.querySelector('.pre-order-info').append(preOrder)
      document.querySelector('.pre-order-info').append(iIcon)
    }
    else {
      var readyStock = document.createElement("div");
      readyStock.className = "ready-stock-container"
      readyStock.innerHTML = "This item is currently in stock!"
      document.querySelector('.pre-order-info').classList.remove('hidden')
      document.querySelector('.pre-order-info').classList.add('green-bg')
      document.querySelector('.pre-order-info').innerHTML = ""
      document.querySelector('.pre-order-info').append(readyStock)  

    }

  }
}




// ---------------------------------------------------------------------------
// 👉 FOOTER
// ---------------------------------------------------------------------------

// Footer Accordion
function showAccordion(e) {
    var x = document.getElementById("accordion-content-container" + e.id);
    var y = document.querySelector(".aci" + e.id);
    var z = document.querySelector(".ar" + e.id);
    if (x.classList.contains("hidden")) {
      x.classList.remove("hidden");
      setTimeout(function(){ y.classList.add("opacity-1"); }, 100);
      z.classList.add("rotate-270");
    } else {
      y.classList.remove("opacity-1");
      setTimeout(function(){ x.classList.add("hidden") }, 500);
      z.classList.remove("rotate-270");
    }
  }








  




// ---------------------------------------------------------------------------
// 👉 SIZE CHART POP UP
// ---------------------------------------------------------------------------

// Show Pop Up
function showSizeChart(e) {
  document.querySelector('.size-chart-popup').style.display = 'block';
  var lazyImages = document.querySelectorAll("img.lazy-size");    
  lazyImages.forEach(function(lazyImage) {
      lazyImage.src = lazyImage.dataset.src;
      lazyImage.classList.remove('lazy-size');
  });

    if (!window.location.href.includes('products')) {
      updateSizeChart(e)

    }
    else {
      open()
    }
  

}

function open() {

  document.querySelector('.size-chart-bg').style.opacity = '1';
  document.querySelector('.size-chart-stage').style.opacity = '1';
  // document.querySelector('.size-chart-stage').style.top = '150px';

}







function updateSizeChart(e) {

  if (e.dataset.sizechart == null) {}
  else {
  var currentProduct = e.dataset.sizechart
  }
fetch('https://sunnyofficial.co/products/' + currentProduct )
.then(response => {
    return response.text();
})
.then (productData => {

    // Create div
    var div = document.createElement("div");
    div.innerHTML = productData;

    var sizeChart = div.querySelector('.size-chart-stage')

  
    if (document.querySelector('.size-chart-drop')) {
    document.querySelector('.size-chart-drop').innerHTML = ''
    document.querySelector('.size-chart-drop').appendChild(sizeChart)        
    }

})
.finally(() => {
  var lazyImages = document.querySelectorAll("img.lazy-size");    
  lazyImages.forEach(function(lazyImage) {
    lazyImage.src = lazyImage.dataset.src;
    lazyImage.classList.remove('lazy-size');
});
  open()
})

}


// CHANGE SIZE CHART

function changeSizeChartSlider(currentElm, otherSlider, currentWrap, otherWrap) {
  console.log(currentElm)
  if (currentElm === 'size-guide-slider') {
    currentElm = document.getElementById('size-guide-slider')
  }
  var otherSliderElm = document.getElementById(otherSlider)
  var currentWrapElm = document.getElementById(currentWrap)
  var otherWrapElm = document.getElementById(otherWrap)

  currentElm.classList.add('active-size-chart-slider')
  otherSliderElm.classList.remove('active-size-chart-slider')
  currentWrapElm.classList.add('hidden')
  otherWrapElm.classList.remove('hidden')

}








// Hide Pop Up

function hideSize() {
  document.querySelector('.size-chart-bg').style.opacity = '0';
  document.querySelector('.size-chart-stage').style.opacity = '0';
  // document.querySelector('.size-chart-stage').style.top = '0px';
  setTimeout(function() {
      document.querySelector('.size-chart-popup').style.display = 'none';
  }, 500)
}





// ATTEMPT TO CHANGE PRICE TO COLUMN FLEX BASED ON TILE SIZE

function changePriceToFlex() {

  if (document.querySelector('.ptile-image-wrapper')) {
  
      // var obj = document.querySelectorAll('.ptile-image-wrapper');
      var flexObj = document.querySelectorAll('.ptile-price-container')
      for (var i = 0; i < flexObj.length; i++) {  
          if (flexObj[i].offsetWidth < 250) {
            flexObj[i].classList.add('flex-price')
          } else {
            flexObj[i].classList.remove('flex-price')
          }
      } 
  }
  }

  window.addEventListener("resize", changePriceToFlex);






 // LAZY LOADING IMAGES


  
 function lazyload() {

  var lazyloadImages = document.querySelectorAll("img.lazy");    
  var lazyloadThrottleTimeout;

  if(lazyloadThrottleTimeout) {
    clearTimeout(lazyloadThrottleTimeout);
  }    
  
  lazyloadThrottleTimeout = setTimeout(function() {

      var scrollTop = window.pageYOffset;
      lazyloadImages.forEach(function(img) {

          if(img.offsetTop < (window.innerHeight + scrollTop)) { // means if the image is in view
            img.src = img.dataset.src;
            img.classList.remove('lazy');
          }
         });
          if(lazyloadImages.length == 0) { 
            document.removeEventListener("scroll", lazyload);
            window.removeEventListener("resize", lazyload);
            window.removeEventListener("orientationChange", lazyload);
          }
  }, 20);
}

window.addEventListener("scroll", lazyload);
window.addEventListener("resize", lazyload);
window.addEventListener("orientationChange", lazyload);
lazyload();

// ADD IN EVENT LISTENER // ON CLICK FOR LOAD MORE COLLECTION RESULTS (PAGINATE)








// LOAD NEXT PAGE -- COLLECTION // PAGINATTE

async function nextColPage(e) {

  e.innerHTML = `<div class=""> Loading...</div>
`;

  var nextPage = e.dataset.nexturl
  var prevPage = e.dataset.prevurl

  // if current url doesn't include page or it's not the home page
  if (!window.location.href.includes('/products')) {
    if (document.querySelector('.fresh-in-tile-wrapper')) {}
      else {
        // Update history to the next url
        history.replaceState(null, null, nextPage.replace('?', '?&'))    
      }
  }

  // Send fetch request to the next page
  const response = await fetch(nextPage);
  const data = await response.text();

  const parser = new DOMParser();
  const newDocument = parser.parseFromString(data, 'text/html');

  // Insert the new products into the DOM
  if (document.querySelector('.collection-grid-container')) {
    document.querySelector('.collection-grid-container').insertAdjacentHTML('beforeend', newDocument.querySelector('.collection-grid-container').innerHTML);
  }

  if (document.querySelector('.fresh-in-tile-wrapper')) {
    document.querySelector('.fresh-in-tile-wrapper').insertAdjacentHTML('beforeend', newDocument.querySelector('.collection-grid-container').innerHTML);
  }


  if (newDocument.querySelector('#tile-pagination')) {        
    document.querySelector('#tile-pagination').replaceWith(newDocument.querySelector('#tile-pagination'));
  } else {
      document.querySelector('#tile-pagination').innerHTML = ""
  }  
  lazyload()

}



// SAME FUNCTION REPEATED FOR INSTANT SEARCH PAGINATION
async function lazyLoadSearchResults(e) {

  e.innerHTML = `<div class=""> Loading...</div>
  `;
  
  var nextPage = e.dataset.nexturl
  var prevPage = e.dataset.prevurl

  // Send fetch request to the next page
  const response = await fetch(nextPage);
  const data = await response.text();

  const parser = new DOMParser();
  const newDocument = parser.parseFromString(data, 'text/html'); // convert string to HTML

  console.log(newDocument)

  // Insert the new products into the DOM
  document.querySelector('.search-results-grid').insertAdjacentHTML('beforeend', newDocument.querySelector('.search-results-grid').innerHTML);

  // finally, change the innerHTML of the pagination to the new pagination
  if (newDocument.querySelector('#tile-pagination-search')) {
    document.querySelector('#tile-pagination-search').replaceWith(newDocument.querySelector('#tile-pagination-search'));
  } else {
      document.querySelector('#tile-pagination-search').innerHTML = ""
  }
    

  lazyload()
  
  
}




// MOVE SORT BASED ON SCREEN SIZE
function movePosition(){
	var windowWidth = document.documentElement.clientWidth;
	if(windowWidth < 1000){
      // move collection sort to different div
      if (window.location.href.includes('/collections')) {
        var collectionSort = document.querySelector('.collection-sort')
        var collectionSortParent = document.querySelector('.collection-sort-2')
        collectionSortParent.appendChild(collectionSort)

        document.querySelector('.collection-mb-quicklinks').appendChild(document.querySelector('.collection-quicklink-container'))
      }

  
    

      if (document.querySelector('.ar222')) {
        document.querySelector('.ar222').classList.remove('rotate-270')
      }

      if (document.getElementById('accordion-content-container222')) {
      document.getElementById('accordion-content-container222').classList.add('hidden')
      }


	}

}

window.addEventListener("resize", movePosition);




function freeGift() {

  if (document.getElementById('Gift-Sub-Title')){
    document.getElementById('Gift-Sub-Title').innerHTML = 'Loading your free gift...'
  }

  fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
    var cart = data
    var cartValue = cart.total_price
    console.log(cartValue)
    if (cartValue > 25800000) { // IF CART VALUE IS OVER 500K

      let hasFreeGift = false
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_type === 'Free Gift') { // If there is already a free gift in the cart

          hasFreeGift = true

          var freeGiftImg = cart.items[i].image
          document.getElementById('Gift-Img').src = freeGiftImg
          var freeGiftTitle = cart.items[i].title
          document.getElementById('Gift-Sub-Title').innerHTML = freeGiftTitle  

        } 
      }
        console.log(hasFreeGift)

        if (hasFreeGift === false) {
          console.log('elsdddde')

          var freeGift = ""
          var freeGiftImg = ""
          var freeGiftTitle = ""

          if (localStorage.getItem('freeGift')) {

            freeGift = localStorage.getItem('freeGift')
            freeGiftImg = localStorage.getItem('freeGiftImg')
            freeGiftTitle = localStorage.getItem('freeGiftTitle')


          } else { 

            freeGift = 44352845742312 // https://thesunnyclothing.com/products/yelena-mesh-sleepwear?variant=M
            freeGiftImg = 'https://sunnyofficial.co/cdn/shop/products/image_b3d19b44-65a5-4af7-b84a-12c89ac13155_200x200.jpg?v=1678512341'
            freeGiftTitle = 'Yelena Mesh Sleepwear - ALL SIZE'

          }

          // Handle old ones
          // if (freeGift === 8256388071656 || freeGift === 8566937878760 || freeGift === 8531596411112 || freeGift === 8566935191784 || freeGift === 8531593756904 || freeGift === 8531591430376 || freeGift === 8531584680168 || freeGift === 8256198115560 || freeGift === 8512247693544 || freeGift === 8664441684200 || freeGift === 8664437489896 ) {
          //   freeGift = 44352845742312 // https://thesunnyclothing.com/products/yelena-mesh-sleepwear?variant=M
          //   freeGiftImg = 'https://thesunnyclothing.com/cdn/shop/products/image_b3d19b44-65a5-4af7-b84a-12c89ac13155_200x200.jpg?v=1678512341'
          //   freeGiftTitle = 'Yelena Mesh Sleepwear - ALL SIZE'
          // }
          // console.log("GIFT", freeGift)


          // Ensure that free gift is value

          const giftNumbers = [
            // Yelina
            44352845742312,
            // Aruna
            44585996550376, 44585996583144, 44585996615912, 44585996648680,
            // Mona
            44586500096232, 44586500129000, 44586500161768, 44586500194536,
            // Helene
            44586501898472, 44586501931240, 44586501964008, 44586501996776,
            // Yura
            44586506191080, 44586506223848, 44586506256616, 44586506289384,
            // Kessie
            44585963192552, 44585963225320, 44585963258088, 44585963290856,
            // Miyra
            45289931964648, 45289931997416, 45289932030184, 45289932062952,
            // Burma
            45353366683880, 45353366716648, 45353366749416, 45353366782184,
            // Miyriba
            45474688041192, 45474688073960, 45474688106728, 45474688139496, 45474688172264,
            // Gracie
            45474686959848, 45474686992616, 45474687025384, 45474687058152, 45474687090920,
            // Kia
            45474682929384, 45474682962152, 45474682994920, 45474683027688,
            // Prilla
            45474686009576, 45474686042344, 45474686075112, 45474686107880, 45474686140648,
            // Saphrie
            45753810059496, 45753810092264, 45753810125032, 45753810157800,
            // Salior
            46320323133672, 46320323166440, 46320323199208, 46320323231976, 46320323264744,
            // jessica
            46320312058088, 46320312090856, 46320312123624, 46320312156392, 46320312189160,
            // clemment
            46320318513384, 46320318546152, 46320318578920, 46320318611688, 46320318644456,
            // Ozuna
            46321042292968, 46321042325736, 46321042358504, 46321042391272, 46321042424040,
            // Ericsa
            46321042653416, 46321042686184, 46321042718952, 46321042751720, 46321042784488,
            // // Miyabi
            45474688041192, 45474688073960, 45474688106728, 45474688139496, 45474688172264,
            // Jessica
            46320312058088, 46320312090856, 46320312123624, 46320312156392, 46320312189160,
            // Erisca
            46321042653416, 46321042686184, 46321042718952, 46321042751720, 46321042784488,
          
        ];
        
        for (let i = 0; i < giftNumbers.length; i++) {
            if (freeGift === giftNumbers[i]) {
              freeGift = 44352845742312 // https://thesunnyclothing.com/products/yelena-mesh-sleepwear?variant=M
              freeGiftImg = 'https://sunnyofficial.co/cdn/shop/products/image_b3d19b44-65a5-4af7-b84a-12c89ac13155_200x200.jpg?v=1678512341'
              freeGiftTitle = 'Yelena Mesh Sleepwear - ALL SIZE'
                break;
            }
        }

        console.log(freeGiftTitle)

          
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    quantity: 1,
                    id: freeGift 
                  }
                ]
              })
            })
            .then(response => {
              if (!response.ok) {
                console.log(response)
              }
            })
            .then(function() {
              fetch('/?view=cart')
              .then(response => response.text())
              .then (cartData => {
                // find element in cart data
                let cartDataElm = document.createElement('div');
                cartDataElm.innerHTML = cartData;
                let stage = cartDataElm.querySelector('#cart-content').innerHTML;
                let currentNumber = cartDataElm.querySelector('#cart-number-inner').innerHTML;
                document.querySelector('#cart-content').innerHTML = stage;    

                if (!document.querySelector('.cart-bottom-area').classList.contains('opacity-1')){
                  setTimeout(() => {
                  document.querySelector('.cart-bottom-area').classList.add('opacity-1')
                  }, 0)
                }
                // if there is no opacity-1 class on .Free-Gift-Wrapper, add
                if (!document.querySelector('.Free-Gift-Wrapper').classList.contains('opacity-1')){
                  setTimeout(() => {
                    document.querySelector('.Free-Gift-Wrapper').classList.add('opacity-1')
                    }, 0)
                }  
                
              })  
              .finally(function() {
                document.getElementById('Gift-Sub-Title').innerHTML = freeGiftTitle
                document.getElementById('Gift-Img').src = freeGiftImg
              })
            //   // Also set the pop up shit
            })
            .finally(function() {})
          
        }
 
    } else { // CUSTOMER HAS SPENT LESS THAN 500K

      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].product_type == 'Free Gift') {

          // Get variant id
          var variantId = cart.items[i].key
          console.log(variantId, 'VARIANT ID')

          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                updates: {
                    [variantId]: 0
                }
            })
        })
        .then(function() {
          //send fetch request
          fetch('/?view=cart')
          .then(response => response.text())
          .then (cartData => {
            console.log('done')
            // find element in cart data
            let cartDataElm = document.createElement('div');
            cartDataElm.innerHTML = cartData;
            let stage = cartDataElm.querySelector('#cart-content').innerHTML;
            let currentNumber = cartDataElm.querySelector('#cart-number-inner').innerHTML;
            document.querySelector('#cart-content').innerHTML = stage;    

            if (!document.querySelector('.cart-bottom-area').classList.contains('opacity-1')){
              setTimeout(() => {
              document.querySelector('.cart-bottom-area').classList.add('opacity-1')
              }, 0)
            }
            // if there is no opacity-1 class on .Free-Gift-Wrapper, add
            if (!document.querySelector('.Free-Gift-Wrapper').classList.contains('opacity-1')){
              setTimeout(() => {
                document.querySelector('.Free-Gift-Wrapper').classList.add('opacity-1')
                }, 0)
            }  

        })  
        })
        .catch(function(error) {
            console.log(error);
        });
        } 
      }
    }
  })
}

function SelectGift(e, productImg, productTitle, productSelector) {
  console.log(e)

  e.innerHTML = "Selecting..."

  var productHandle = document.getElementById(productSelector).value
  console.log(productHandle)

  console.log(productHandle, productImg, productTitle)

  // Check if there is any products in the cart with product type of free gift
  fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
    var cart = data
    console.log(data)

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_type === 'Free Gift') { // If there is already a free gift in the cart

        // remove it from the cart
        var variantId = cart.items[i].key
        console.log(variantId, 'VARIANT ID')

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {

              'Content-type': 'application/json'
          },
          body: JSON.stringify({
              updates: {
                  [variantId]: 0
              }
          })
      })
      .catch(error => console.log(error))
      // .then(function() {
      //   //send fetch request
      //   fetch('/?view=cart')
      //   .then(response => response.text())
      //   .then (cartData => {
      //     console.log('done')
      //     // find element in cart data
      //     let cartDataElm = document.createElement('div');
      //     cartDataElm.innerHTML = cartData;
      //     let stage = cartDataElm.querySelector('#cart-content').innerHTML;
      //     let currentNumber = cartDataElm.querySelector('#cart-number-inner').innerHTML;
      //     document.querySelector('#cart-content').innerHTML = stage;    
      // })  
      // })
      .finally (function() {
  // Add the new free gift to the cart
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: [
        {
          quantity: 1,
          id: productHandle
        }
      ]
    })
  })
  .then(function() {
    e.innerHTML = "Selected!"
    fetch('/?view=cart')
    .then(response => response.text())
    .then (cartData => {
      // find element in cart data
      let cartDataElm = document.createElement('div');
      cartDataElm.innerHTML = cartData;
      let stage = cartDataElm.querySelector('#cart-content').innerHTML;
      let currentNumber = cartDataElm.querySelector('#cart-number-inner').innerHTML;
      document.querySelector('#cart-content').innerHTML = stage;    

      if (!document.querySelector('.cart-bottom-area').classList.contains('opacity-1')){
        setTimeout(() => {
        document.querySelector('.cart-bottom-area').classList.add('opacity-1')
        }, 0)
      }
      // if there is no opacity-1 class on .Free-Gift-Wrapper, add
      if (!document.querySelector('.Free-Gift-Wrapper').classList.contains('opacity-1')){
        setTimeout(() => {
          document.querySelector('.Free-Gift-Wrapper').classList.add('opacity-1')
          }, 0)
      }  




    })  
    .finally(function() {
      HideFreeGiftPop()

      var VariantTitle = document.getElementById(productSelector).selectedOptions[0].innerText;
      console.log(VariantTitle)

      setTimeout(function() {
      document.getElementById('Gift-Img').src = productImg
      document.getElementById('Gift-Sub-Title').innerHTML = productTitle + ' - ' + VariantTitle
      }, 1000)


      localStorage.setItem('freeGift', productHandle)
      localStorage.setItem('freeGiftImg', productImg)
      localStorage.setItem('freeGiftTitle', productTitle + ' - ' + VariantTitle)

      e.innerHTML = "Select"
    })
  })
      })

      } 
    }

  })







}




function ShowFreeGiftPop() {
  document.querySelector('.free-gift-pop-wrapper').classList.remove('hidden')

  // For every class of Free-Gift-Main-Img, change data-src to src
  var freeGiftMainImg = document.querySelectorAll('.Free-Gift-Main-Img')
  for (var i = 0; i < freeGiftMainImg.length; i++) {
    freeGiftMainImg[i].src = freeGiftMainImg[i].dataset.src
  }



}

function HideFreeGiftPop() {
  document.querySelector('.free-gift-pop-wrapper').classList.add('hidden')
}

